import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import deductible from '../page/deductible.vue';
import account from '../page/deduction_account.vue';
import multiPerson from '../page/multi_person_deduction.vue';
import solidBuckle from '../page/solid_buckle.vue';
import parameter from '../page/parameter_manage.vue';
import item from '../page/deductions_item.vue';
import dept from '../page/deductions_dept.vue';
import blackList from "../page/blackList.vue";
import chargeManage from "../page/chargeManage.vue";
import report from "../page/report.vue";
import axios from 'axios'; //引入axios
import store from '@/store'
import rootUrl from "../utils/api";

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'

const router = new VueRouter({
	// mode: 'history',
	// base: '/chargeweb/',
	routes: [
		// {
		//     path: '*',
		//     redirect: '/chargeweb/'
		// },
		{
			path: '/deductible',
			component: deductible,
			name: "deductible",
			meta: {
				isLogin: true,
				title: '应扣管理'
			}
		},
		{
			path: '/account',
			component: account,
			name: "account",
			meta: {
				isLogin: true,
				title: '扣款台帐'
			}
		},
		{
			path: '/multiPerson',
			component: multiPerson,
			name: "multiPerson",
			meta: {
				isLogin: true,
				title: '多人扣款'
			}
		},
		{
			path: '/',
			component: solidBuckle,
			name: "solidBuckle",
			meta: {
				isLogin: true,
				title: '实扣管理'
			}
		},
		{
			path: '/parameter',
			component: parameter,
			name: "parameter",
			meta: {
				isLogin: true,
				title: '参数管理'
			}
		},
		{
			path: '/item',
			component: item,
			name: "item",
			meta: {
				isLogin: true,
				title: '扣款项目'
			}
		},
		{
			path: '/dept',
			component: dept,
			name: "dept",
			meta: {
				isLogin: true,
				title: '部门扣款'
			}
		},
		{
			path: '/blackList',
			component: blackList,
			name: "blackList",
			meta: {
				isLogin: true,
				title: '黑名单人员'
			}
		},
		{
			path: '/chargeManage',
			component: chargeManage,
			name: "chargeManage",
			meta: {
				isLogin: true,
				title: '黑名单扣款'
			}
		},
		{
			path: '/report',
			component: report,
			name: "report",
			beforeEnter(){
				location.href = "http://pbi.centaline.com.cn/Reports/powerbi/%E5%8D%8E%E8%A5%BF/%E4%B8%AD%E5%8E%9F%E9%AD%94%E6%95%B0/%E6%89%A3%E6%AC%BE%E7%9B%91%E6%8E%A7";
			},
			meta: {
				isLogin: true,
				title: '扣款报表'
			}
		}
	]
})


const request = (name) => {
	//获取?后面的参数
	// alert(name)
	let arr = window.location.href;
	let index = arr.lastIndexOf("?");
	arr = arr.substring(index + 1, arr.length);
	var query = arr;
	var param_arr = query.split("&");
	for (var i = 0; i < param_arr.length; i++) {
		var pair = param_arr[i].split("=");
		if (pair[0] == name) {
			return pair[1].replace('#/', '');
		}
	}
	return false;
}

// 全局路由守卫
router.beforeEach((to, from, next) => {


	if (store.state.login) {
		next();
	} else {
		var code = request('code');
		if (code) {
			// 保存信息
			axios.get(rootUrl + `/login/login-by-code?code=${code}`)
				.then(function(res) { //请求成功，response接收返回参数
					// console.log(res);
					if (res.data.code == 200) {
						store.state.login = true;
						store.state.loginToken = res.data.data.token;
						store.state.loginInfo = res.data.data.user;
						if (res.data.data.user.roles != null) {
							for (let i = 0; i < res.data.data.user.roles.length; i++) {
								if (res.data.data.user.roles[i] == "管理员") {
									store.state.isAdmin = true;
									break;
								}
							}
						}
						next();
					} else {
						ElementUI.Message({
							message: res.data.message,
							type: "error",
							duration: 5000,
							center: true,
						})
						next();
					}
					//  else if(res.data.code == 2001){
					// window.location.href =
					//     "https://cdsso.centaline.com.cn/sso/sso-oauth/authorize?clienttype=qy&appid=5e18b492-a87c-4aeb-aead-1ba590d80224&redirect_uri=" +
					//     encodeURIComponent(window.location.href);
					// }


				})
				.catch(function(error) { //请求失败，error接收失败原因
					console.log(error);
				})
		} else {
			window.location.href =
				"https://cdsso.centaline.com.cn/sso/sso-oauth/authorize?clienttype=pc&appid=5e18b492-a87c-4aeb-aead-1ba590d80224&redirect_uri=" +
				encodeURIComponent(window.location.href);
		}
	}

	// next() // 必须使用 next ,执行效果依赖 next 方法的调用参数
})

export default router
